import React, { useEffect, useState } from 'react';
import close_button from '../../../assets/close_button.png';
import ImModuleStyle from '../styles/im.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);

const RevenueGraph = ({ type, isDecisionPopup, showDecisionPopupHandler, hideDecisionPopupHandler, simObj, setSimObj, isResult, summaryGraphData, attempt }) => {
  const [gGraphStyle, setGGraphStyle] = useState({ left: 0, top: 0 });
  const [monthlydata, setMonthlyData] = useState('');
  const [RevenueData, setRevenueData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [CostsData, setCostsData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [xAxisMinMax, setXAxisMinMax] = useState({ "monthly": { min: 1, max: 31 }, "quarterly": { min: 0, max: 3 }, "yearly": { min: 0, max: 12 } });
  const [dpObject, setDpObject] = useState({});
  const [isShowD, setIsShowD] = useState(true);
  const [revenueGraphLabel, setRevenueGraphLabel] = useState("");
  const [chart, setChart] = useState(null);
  const [point, setPoint] = useState(null);

  let graphSettings = {}
  const handleDrag = (e, draggableData) => {
    //setLeftPosition(leftPosition + draggableData.x);
  };
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  // let RevenueData = {
  //   "monthly": [],
  //   "yearly": [],
  //   "quarterly": []
  // }
  // let CostsData = {
  //   "monthly": [],
  //   "yearly": [],
  //   "quarterly": []
  // }
  const setGraphData = () => {
    if (chart) {
      let revenueMonthlyData = [];
      let revenueQuarterlyData = [];
      let revenueYearlyData = [];
      let costMonthlyData = [];
      let costQuaerterlyData = [];
      let costYearlyData = [];
      let monthDays = 0;
      let newPoint = "";
      let existingData = "";
      let newData = "";
      let date = new Date();
      chart?.yAxis[0]?.update({ min: 0, max: undefined });
      switch (type) {
        case "monthly":
          revenueMonthlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm === simObj?.laststate?.statemonth) {
              return true;
            }
          });
          revenueMonthlyData = (revenueMonthlyData != undefined ? revenueMonthlyData : []).map((data) => {
            return {
              x: data.sd,
              y: data.rv,
              revenue: data.rv,
              purchaseCost: data.dc,
              holdingCost: data.dh,
              orderingCost: data.do,
              stockoutCost: data.ds,
              totalCost: data.tc,
              demandCost: data.dd,
              date: getDate(data.cd),
              quantityordered: data.qo,
              event: data.ev
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            monthly: revenueMonthlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            monthly: { min: 1, max: new Date(date.getFullYear(), date.getMonth(), 0).getDate() }
          }));
          if (revenueMonthlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueMonthlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[0]?.options?.data;
            // newData = [...existingData, revenueMonthlyData[revenueMonthlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueMonthlyData[revenueMonthlyData.length - 1].x) {
                  existingData[index] = revenueMonthlyData[revenueMonthlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueMonthlyData[revenueMonthlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series[0]?.setData(newData);
          }
          (revenueMonthlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          //Cost Data
          costMonthlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm === simObj?.laststate?.statemonth) {
              return true;
            }
          });
          costMonthlyData = (costMonthlyData != undefined ? costMonthlyData : []).map((data) => {
            return {
              x: data.sd,
              y: data.tc,
              revenue: data.rv,
              purchaseCost: data.dc,
              holdingCost: data.dh,
              orderingCost: data.do,
              stockoutCost: data.ds,
              totalCost: data.tc,
              date: getDate(data.cd),
              quantityordered: data.qo,
              event: data.ev
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            monthly: costMonthlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            monthly: { min: 1, max: new Date(date.getFullYear(), date.getMonth(), 0).getDate() }
          }));

          if (costMonthlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costMonthlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[1]?.options?.data;
            // newData = [...existingData, costMonthlyData[costMonthlyData.length - 1]];

            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costMonthlyData[costMonthlyData.length - 1].x) {
                  existingData[index] = costMonthlyData[costMonthlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costMonthlyData[costMonthlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series[1]?.setData(newData);
          }
          (simObj?.laststate?.stateyear != undefined && simObj?.laststate?.statemonth != undefined) && chart?.xAxis[0]?.update({ min: 1, max: getMonthDays(simObj?.laststate?.stateyear, simObj?.laststate?.statemonth) });
          (costMonthlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "quarterly":
          revenueQuarterlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm >= simObj?.laststate?.statemonth - 2) {
              return true;
            }
          });
          revenueQuarterlyData = (revenueQuarterlyData != undefined ? revenueQuarterlyData : []).map((data) => {
            return {
              x: ((data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm))),
              y: data.rv,
              revenue: data.rv,
              purchaseCost: data.dc,
              holdingCost: data.dh,
              orderingCost: data.do,
              stockoutCost: data.ds,
              totalCost: data.tc,
              demandCost: data.demandCost,
              date: getDate(data.cd),
              quantityordered: data.qo,
              event: data.ev
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            quarterly: revenueQuarterlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            quarterly: { min: simObj?.laststate?.statemonth - 3, max: simObj?.laststate?.statemonth }
          }));

          if (revenueQuarterlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueQuarterlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[0]?.options?.data;
            // newData = [...existingData, revenueQuarterlyData[revenueQuarterlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueQuarterlyData[revenueQuarterlyData.length - 1].x) {
                  existingData[index] = revenueQuarterlyData[revenueQuarterlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueQuarterlyData[revenueQuarterlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }

            // Update the series data with the new data
            chart?.series[0]?.setData(newData);
          }

          (revenueQuarterlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });

          //Cost Data
          costQuaerterlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm >= simObj?.laststate?.statemonth - 2) {
              return true;
            }
          });
          costQuaerterlyData = (costQuaerterlyData != undefined ? costQuaerterlyData : []).map((data) => {
            return {
              x: ((data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm))),
              y: data.tc,
              revenue: data.rv,
              purchaseCost: data.dc,
              holdingCost: data.dh,
              orderingCost: data.do,
              stockoutCost: data.ds,
              totalCost: data.tc,
              date: getDate(data.cd),
              quantityordered: data.qo,
              event: data.ev
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            quarterly: costQuaerterlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            quarterly: { min: simObj?.laststate?.statemonth - 3, max: simObj?.laststate?.statemonth }
          }));

          if (costQuaerterlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costQuaerterlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[1]?.options?.data;
            // newData = [...existingData, costQuaerterlyData[costQuaerterlyData.length - 1]];

            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costQuaerterlyData[costQuaerterlyData.length - 1].x) {
                  existingData[index] = costQuaerterlyData[costQuaerterlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costQuaerterlyData[costQuaerterlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            chart?.series[1]?.setData(newData);
          }
          // if ((simObj?.laststate?.statemonth - 1) % 3 == 0) {
          //   chart?.xAxis[0]?.update({
          //     min: simObj?.laststate?.statemonth - 1,
          //     max: simObj?.laststate?.statemonth + 2
          //   });
          // }
          let min = 0, max = 0;
          if (simObj?.laststate?.statemonth / 3 >= 0 && simObj?.laststate?.statemonth / 3 <= 1) {
            min = 0;
            max = 3;
          }
          else if (simObj?.laststate?.statemonth / 3 > 1 && simObj?.laststate?.statemonth / 3 <= 2) {
            min = 3;
            max = 6;
          }
          else if (simObj?.laststate?.statemonth / 3 > 2 && simObj?.laststate?.statemonth / 3 <= 3) {
            min = 6;
            max = 9;
          }
          else if (simObj?.laststate?.statemonth / 3 > 3 && simObj?.laststate?.statemonth / 3 <= 4) {
            min = 9;
            max = 12;
          }
          chart?.xAxis[0]?.update({
            // min: simObj?.laststate?.statemonth-1,
            // max: simObj?.laststate?.statemonth+2
            min: min,
            max: max
          });
          (costQuaerterlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "yearly":
          revenueYearlyData = simObj?.graphdata;
          revenueYearlyData = (revenueYearlyData != undefined ? revenueYearlyData : []).map((data) => {
            return {
              x: ((data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm))),
              y: data.rv,
              revenue: data.rv,
              purchaseCost: data.dc,
              holdingCost: data.dh,
              orderingCost: data.do,
              stockoutCost: data.ds,
              totalCost: data.tc,
              demandCost: data.demandCost,
              date: getDate(data.cd),
              quantityordered: data.qo,
              event: data.ev
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            yearly: revenueYearlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            yearly: { min: 0, max: 12 }
          }));

          if (revenueYearlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueYearlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[0]?.options?.data;
            // newData = [...existingData, revenueYearlyData[revenueYearlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueYearlyData[revenueYearlyData.length - 1].x) {
                  existingData[index] = revenueYearlyData[revenueYearlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueYearlyData[revenueYearlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series[0]?.setData(newData);
          }
          (revenueYearlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          //Cost Data
          costYearlyData = simObj?.graphdata;
          costYearlyData = (costYearlyData != undefined ? costYearlyData : []).map((data) => {
            return {
              x: ((data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm))),
              y: data.tc,
              revenue: data.rv,
              purchaseCost: data.dc,
              holdingCost: data.dh,
              orderingCost: data.do,
              stockoutCost: data.ds,
              totalCost: data.tc,
              date: getDate(data.cd),
              quantityordered: data.qo,
              event: data.ev
            }
          });

          setCostsData(prevData => ({
            ...prevData,
            yearly: costYearlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            yearly: { min: 0, max: 12 }
          }));

          if (costYearlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costYearlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[1]?.options?.data;
            // newData = [...existingData, costYearlyData[costYearlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costYearlyData[costYearlyData.length - 1].x) {
                  existingData[index] = costYearlyData[costYearlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costYearlyData[costYearlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series[1]?.setData(newData);
          }
          chart?.xAxis[0]?.update({
            min: 0,
            max: 12
          });
          (costYearlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        default:
          break;
      }
      setDataLabel((simObj?.graphdata != undefined) ? simObj?.graphdata : []);
    }
  }
  const setDataLabel = (graphdata) => {
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    if (chart) {
      for (let i = 0; i < chart.series.length; i++) {
        chart.series[1].update({
          //data: newData,
          dataLabels: {
            enabled: (isResult != undefined && isResult) ? false : true,
            formatter: function () {
              let currDate = Number(this.point.date.split(",")[0].split(" ")[1]);
              let currMonth = Number(months.indexOf(this.point.date.split(",")[0].split(" ")[0]) + 1);
              let newEGraphData = graphdata.filter(function (gObj) {
                if (gObj.sm == currMonth && gObj.sd == currDate) {
                  return gObj;
                }
              })[0];
              this.point.dataLabel?.element.setAttribute("event", null)
              if (this.point.quantityordered > 0 && chart.series[0].name == 'Revenue') {
                return `<div className=${`${ImModuleStyle.decision}`}><span>D</span><div>`;
              }
              else {
                return null;
              }

            }
          }
        });
        chart.series[0].update({
          //data: newData,
          dataLabels: {
            enabled: (isResult != undefined && isResult) ? false : true,
            backgroundColor: "#400000",
            formatter: function () {
              let currDate;
              let currMonth;
              let Currpoint= this.point;
              if ((Currpoint.date.indexOf(",") != -1)) {
                currMonth = Number(months.indexOf(Currpoint.date.split(",")[0].split(" ")[0]) + 1);
                currDate = Number(Currpoint.date.split(",")[0].split(" ")[1]);
              } else {
                currMonth = Number(months.indexOf(Currpoint.date.split(" ")[1]) + 1);
                currDate = Number(Currpoint.date.split(" ")[0]);
              }
              let newEGraphData = graphdata.filter(function (gObj) {
                if (gObj.sm == currMonth && gObj.sd == currDate) {
                  return gObj;
                }
              })[0];
              this.point.dataLabel?.element.setAttribute("event", newEGraphData?.ev)
              if (Object.keys((newEGraphData != undefined) ? newEGraphData : {}).length > 0 && newEGraphData?.ev != null && chart.series[1].name == 'Costs') {
                return `<div className=${`${ImModuleStyle.event}`}><span>E</span><div>`;
              }
              else {
                return null;
              }

            }
          }
        });

        chart.series[i].data.forEach(function (point) {
          if ((point.dataLabel != undefined) && (point.dataLabel != "")) {
            let currMonth;
            let currDate;
            if ((point.date.indexOf(",") != -1)) {
              currMonth = Number(months.indexOf(point.date.split(",")[0].split(" ")[0]) + 1);
              currDate = Number(point.date.split(",")[0].split(" ")[1]);
            } else {
              currMonth = Number(months.indexOf(point.date.split(" ")[1]) + 1);
              currDate = Number(point.date.split(" ")[0]);
            }
            let newDGraphData = graphdata.filter(function (gObj) {
              if (gObj.sd == currDate && currMonth == gObj.sm) {
                return gObj;
              }
            })[0];
            point.dataLabel.element.setAttribute("quantityordered", newDGraphData?.qo)
            point.dataLabel.element.setAttribute("date", point.date)
            point.dataLabel.element.setAttribute("shippingtype", newDGraphData?.st)
            point.dataLabel.element.addEventListener('click', showPopUp);
          }
        });

      }
    }
  }

  const openModalWithData = (point) => {
    const dataLabelElement = point.dataLabel && point.dataLabel.element;
    if (dataLabelElement) {
      setPoint(point.graphic.element);
      dataLabelElement.setAttribute("tabindex", "0");
      dataLabelElement.setAttribute("role", "button");
      dataLabelElement.focus();
      dataLabelElement.addEventListener('keyup', function (event) {
        if (event.key === 'Enter' || event.key === 'Space') {
          showPopUp(event);
        }
      });
      // dataLabelElement.addEventListener('keyup', function (event) {
      //   if (event.key === 'Enter' || event.key === 'Space') {
      //     // Handle keydown event (e.g., open modal) here
      //     alert('Keyup event triggered',counter++);
      //     point.dataLabel.element.addEventListener('keyup', showPopUp);
      //     // Replace with your keydown event handling logic
      //   }
      // });
    }
  }
  const showPopUp = (e) => {
    //setGGraphStyle({ left: e.offsetX - 10, top: e.offsetY + 15 })
    var isFirefox = /Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent);
    let left, top;
    const g_container = ImModuleStyle['graph-container'];
    const g_wrapper = ImModuleStyle['graph-wrapper'];
    if (isFirefox) {
      /*left = e.pageX - document.getElementsByClassName(`${g_wrapper}`)[0].offsetLeft - document.querySelector(".App").offsetLeft;
      top = e.pageY - document.getElementsByClassName(`${g_wrapper}`)[0].offsetTop - document.querySelector(".App").offsetTop - document.getElementsByClassName(`${g_container}`)[0].offsetTop;
      setGGraphStyle({ left: left - 12, top: top + 15 });*/
      left = window.$(e.currentTarget).offset().left - document.getElementsByClassName(`${g_wrapper}`)[0].offsetLeft - document.querySelector(".App").offsetLeft;
      top = window.$(e.currentTarget).offset().top - document.getElementsByClassName(`${g_wrapper}`)[0].offsetTop - document.querySelector(".App").offsetTop - document.getElementsByClassName(`${g_container}`)[0].offsetTop;
      setGGraphStyle({ left: left - 4, top: top + 22 })
    } else if (e.offsetLeft != undefined && e.offsetTop != undefined) {
      setGGraphStyle({ left: e.offsetX - 10, top: e.offsetY + 15 })
    } else {
      left = window.$(e.currentTarget).offset().left - document.getElementsByClassName(`${g_wrapper}`)[0].offsetLeft - document.querySelector(".App").offsetLeft;
      top = window.$(e.currentTarget).offset().top - document.getElementsByClassName(`${g_wrapper}`)[0].offsetTop - document.querySelector(".App").offsetTop - document.getElementsByClassName(`${g_container}`)[0].offsetTop;
      setGGraphStyle({ left: left - 40, top: top + 22 })
    }
    var element = document.getElementById('RevenueGraph');
    element.style.overflow = 'visible';
    showDecisionPopupHandler();
    setDpObject({ "quantityordered": e.currentTarget.getAttribute('quantityordered'), "date": e.currentTarget.getAttribute('date'), "shippingtype": e.currentTarget.getAttribute('shippingtype'), "event": e.currentTarget.getAttribute('event') })
    if (e.currentTarget.getAttribute('event') == 'null') { setIsShowD(true) } else { setIsShowD(false) };
  }
  const formatterFun = (type) => {

    switch (type) {
      case "monthly":
        return function () {
          return `
            <div className=${`${ImModuleStyle.tooltip}`}>
              <div>Day: ${this.point.date}</div>
              <div>Revenue: $${this.point.revenue} </div>
              <div>Purchase Cost: $${this.point.purchaseCost}</div>
              <div>Holding Cost: $${this.point.holdingCost}</div>
              <div>Ordering Cost: $${this.point.orderingCost}</div>
              <div>Stockout Cost: $${this.point.stockoutCost}</div>
              <div>Total Cost: $${this.point.totalCost}</div>
              ${this.point.demandCost ? `<div>Demand: ${this.point.demandCost}</div>` : ``}              
            </div>
          `;
        };
      case "quarterly":
        return function () {
          return `
            <div className=${`${ImModuleStyle.tooltip}`}>
              <div>Day: ${this.point.date}</div>
              <div>Revenue: $${this.point.revenue} </div>
              <div>Purchase Cost: $${this.point.purchaseCost}</div>
              <div>Holding Cost: $${this.point.holdingCost}</div>
              <div>Ordering Cost: $${this.point.orderingCost}</div>
              <div>Stockout Cost: $${this.point.stockoutCost}</div>
              <div>Total Cost: $${this.point.totalCost}</div>
              ${this.point.demandCost ? `<div>Demand: ${this.point.demandCost}</div>` : ``}              
            </div>
          `;
        };
      case "yearly":
        return function () {
          return `
            <div className=${`${ImModuleStyle.tooltip}`}>
              <div>Day: ${this.point.date}</div>
              <div>Revenue: $${this.point.revenue} </div>
              <div>Purchase Cost: $${this.point.purchaseCost}</div>
              <div>Holding Cost: $${this.point.holdingCost}</div>
              <div>Ordering Cost: $${this.point.orderingCost}</div>
              <div>Stockout Cost: $${this.point.stockoutCost}</div>
              <div>Total Cost: $${this.point.totalCost}</div>
              ${this.point.demandCost ? `<div>Demand: ${this.point.demandCost}</div>` : ``}              
            </div>
          `;
        };
      default:
        return null;
    }

  }

  function applyAccessibility(chart) {
      if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
          svg.setAttribute("role", "img");
          svg.setAttribute(
          "aria-label",
          "Line chart showing daily revenue and costs for the current month."
          );

          const oldDesc = svg.querySelector("desc");
          if (oldDesc) oldDesc.remove();

          const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
          desc.textContent =
          "This line chart tracks revenue and costs for each day of the current month. The x-axis represents the days of the month from 1 to 30, while the y-axis shows dollar values.";
          svg.insertBefore(desc, svg.firstChild);
        },0);
      }
      }
  }

  const xAxis = {
    "monthly": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      tickLength: 0,
      crosshair: {
        snap: false,
        width: 1,
        color: '#C9C8B9',
        zIndex: 5
      },
      accessibility: {
        point: {

        }
      },
      title: {
        text: "Day of Month",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0
      }

    },
    "quarterly": {
      categories: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      // max:3,
      tickmarkPlacement: 'on',
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      tickLength: 0,
      title: {
        text: "Month",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      rangeSelector: {
        selected: 1
      },
      accessibility: {
        point: {

        }
      },
      crosshair: {
        snap: false,
        width: 1,
        color: '#C9C8B9',
        zIndex: 5
      }
    },
    "yearly": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 3,
      tickLength: 0,
      title: {
        text: "Quarter",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      accessibility: {
        point: {

        }
      },
      categories: ['', '', '', 'Q1', '', '', 'Q2', '', '', 'Q3', '', '', 'Q4'],
      tickmarkPlacement: 'on',
      crosshair: {
        snap: false,
        width: 1,
        color: '#C9C8B9',
        zIndex: 5
      }
    }
  }
  const yAxis = {
    "monthly": {
      //min: 0,
      // max: 10000000,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      startOnTick: true,
      color: 'rgb(255,255,255)',
      title: {
        text: "Cost/Revenue ($)",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }

      },

    },
    "quarterly": {
      //min: 0,
      // max: 10000000,
      maxPadding: 0.1,
      tickInterval: null,
      startOnTick: true,
      tickAmount: 6,
      color: 'rgb(255,255,255)',
      title: {
        text: "Cost/Revenue ($)",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }
      }
    },
    "yearly": {
      //min: 0,
      // max: 10000000,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      startOnTick: true,
      title: {
        text: "Cost/Revenue ($)",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      // tickInterval: 2000000,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0, ',', ',');
        }
      }

    }
  }
  // const initGraph = () => {
  //   setGraphSettings();
  //   Highcharts.chart("RevenueGraph", graphSettings);
  // }
  /*const moveRevenueSlider = (event) =>{ 
    event.preventDefault();
    var max=Math.round(window.$("#RevenueGraph").width() - 12);
    var min=95;
    var keyCode = {'LEFT': 37,'UP': 38,'RIGHT': 39,'DOWN': 40};
    if (window.event) {
        var key = window.event.keyCode;
    } else if (event) {
        var key = event.keyCode;
    }
    var isValidate = (leftPosition >= min && leftPosition <= max);
    switch (key) {
      case keyCode.LEFT:
          (isValidate) ? setLeftPosition((leftPosition - 1) == (min-1) ? min : (leftPosition-1)) : setLeftPosition(min);        
          break;
      case keyCode.RIGHT:
            (isValidate) ? setLeftPosition((leftPosition + 1) == (max+1) ? max  : (leftPosition+1)) : setLeftPosition(max);   
            break;
      case keyCode.UP:
          (isValidate) ? setLeftPosition((leftPosition + 1) == (max+1) ? max  : (leftPosition+1)) : setLeftPosition(max);   
            break;
      case keyCode.DOWN:
           (isValidate) ? setLeftPosition((leftPosition - 1) == (min-1) ? min : (leftPosition-1)) : setLeftPosition(min); 
            break;      
       default:
            break;
    }
    
  }*/

  graphSettings = {
    plotOptions: {
      line: {
        fillColor: {
          pattern: {
            path: {
              d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
              strokeWidth: 3
            },
            width: 10,
            height: 10,
            opacity: 0.4
          }
        }
      },
      events: {
        legendItemClick: function () {
          return false; // Prevent default legend item click behavior
        }
      },
      series: {
        stickyTracking: false,
        marker: {
          enabled: true,
        },
        pointPlacement: "on",
        dataLabels: {
          enabled: true,
          backgroundColor: "#000",
          color: "#fff",
          shape: "circle",
          style: {
            cursor: 'pointer',
          }
          // formatter: function () {
          // 	return this.point.Entry_type;
          // }
          /*formatter: function () {
            if (this.point.x === 3) {
              return `<div className="decision"><span>D</span><div>`;
            } else if (this.point.x === 7) {
              return `<div className="event"><span>E</span><div>`;
            }
            else {
              return null; // For other points, don't show the data label
            }
          },*/
          // style: {
          //   fontWeight: 'bold',
          //   fontSize: '12px',
          //   color: '#000',
          // },
        },
        states: {
          inactive: {
            enabled: false
            //opacity:1
          },
          hover: {
            halo: {
              size: 7,
              opacity: 0.5,
            },

          }
        },
        point: {
          events: {
            click: function () {
              openModalWithData(this);
            }
          }
        }
      }
    },
    chart: {
      type: "line",
      responsive: false,
      marginRight: 15,
      // marginTop: 3,
      height: 200,
      plotBorderWidth: 1,
      panning: type === "quarterly",
      events: {
        load: function () {
          var chart = this;
          chart?.series[0]?.data?.forEach(function (point) {
            if ((point.dataLabel != undefined) && (point.dataLabel != "")) {
              // console.log(point.dataLabel)
              point.dataLabel.element.addEventListener('click', showPopUp);
            }
          });

        },
        render: function () {
            applyAccessibility(this);
        },
        redraw: function () {
            applyAccessibility(this);
        }
      }
    },
    title: null,
    legend: {
      enabled: false,
      align: 'left',
      verticalAlign: 'top',
      // floating: true,
      visible: true,
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '12px'
      }
    },
    xAxis: xAxis[type],
    yAxis: yAxis[type],
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        return `Day: ${point.date}; Revenue: $${point.revenue}; Purchase Cost: $${point.purchaseCost}; Holding Cost: $${point.holdingCost}; Ordering Cost: $${point.orderingCost}; Stockout Cost: $${point.stockoutCost}; Total Cost: $${point.totalCost}; ${point.demandCost ? `<div>Demand: ${point.demandCost}</div>` : ``}
        `;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      } 
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Revenue",
        lineWidth: 2,
        data: [],
        color: "#353d6e",
        //fillColor: "#D1DFE2",
        fillColor: {
          pattern: {
            color: '#353d6e'
          }
        },
        marker: {
          enabled: type === "monthly",
          radius: 3,
        },
        /*states: {
          hover: {
            enabled: type === "monthly" || "quarterly" || "yearly"
          }
        }*/
      },
      {
        name: "Costs",
        lineWidth: 2,
        data: [],
        color: "#e6151f",
        //fillColor: "#FBE4D4",
        fillColor: {
          pattern: {
            color: '#e6151f'
          }
        },
        marker: {
          //symbol: "circle",
          enabled: type === "monthly", // Enable markers only for "monthly" type
          //radius: 3,
        },
        /*states: {
          hover: {
            enabled: type === "monthly" || "quarterly" || "yearly"
          }
        }*/
      }
    ],
    tooltip: {
      enabled: (isResult != undefined && isResult) ? false : true,
      shared: false,
      useHTML: true, // Enable HTML content in tooltip
      hideDelay: 0,
      headerFormat: '',
      formatter: formatterFun(type),
      style: {
        color: '#fff'
      },
      valueDecimals: 0,
      backgroundColor: '#000',
      borderColor: '#000',
      borderRadius: 0,
      borderWidth: 3,
    }

  }


  useEffect(() => {
    const newChart = Highcharts.chart("RevenueGraph", graphSettings);
    newChart.series[0].update({ zIndex: 2, type: "line" });
    newChart.series[1].update({ zIndex: 2, type: "line" });
    setChart(newChart);
    if(type === "monthly" || type ==="quarterly" || type ==="yearly"){
      const g_container = ImModuleStyle['graph-container'];
    let gContainer = document.getElementsByClassName(`${ g_container }`)[0];
    gContainer.setAttribute("tabindex",'-1');
    gContainer.focus();
    }
    
  }, [type]);

  useEffect(() => {
    if (isResult && chart) {
      chart?.series[0]?.setData([]);
      chart?.series[1]?.setData([]);
      setSimObj((prevObj) => ({
        ...prevObj,
        graphdata: summaryGraphData,
      }));
    }
    else {
      if(simObj?.graphdata !=  undefined){
        setGraphData();
      }
    }
    if (chart) {
      setRevenueGraphLabel(`Cost and revenue graph representing revenue along Y-axis with ${chart.yAxis[0].tickInterval}$ per unit scale and Time quarter along X-axis with 1 quarter per unit scale.`);
      document.querySelector("#RevenueGraph").setAttribute('role', `figure`);
      document.querySelector("#RevenueGraph .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.laststate, simObj?.currentstep, summaryGraphData]);
  useEffect(() => {
    if (isResult) {
      setGraphData();
    }
  }, [simObj, isResult, summaryGraphData])
  useEffect(() => {
    if (document.querySelector(`.${ImModuleStyle['data-label-popup']} img`) != null) {
      document.querySelector(`.${ImModuleStyle['data-label-popup']} img`).tabIndex = -1;
      document.querySelector(`.${ImModuleStyle['data-label-popup']} img`).focus();
    }
    if (document.querySelector(`.${ImModuleStyle['data-label-popup']}`) == null) {
      if(point){
        point.focus();
      }
    }
    }, [isDecisionPopup]);

  return (
    <div className={`${ImModuleStyle['graph-container']}`} id={type=="monthly" ? "tabpanel-1" : type=="quarterly" ? "tabpanel-2" : "tabpanel-3"} role="tabpanel" aria-labelledby={type=="monthly" ? "tab-1" : type=="quarterly" ? "tab-2" : "tab-3"}>
      {!simObj?.graphdata?.length && <div className={`${ImModuleStyle['nodata-alert-revenue']}`}>Costs and Revenues will appear here as the simulation runs</div>}
      <span></span>
      <a href="#" onClick={(e)=> e.preventDefault()} aria-label="Legends: line with round bullet for Revenue and line with Rhombus got Cost" className="sr-only"></a>
      <div id="RevenueGraph" className={`${ImModuleStyle['revenue-graph']}`} aria-label={revenueGraphLabel} role='figure'>
        {
          isDecisionPopup && <div style={gGraphStyle} className={`${ImModuleStyle['data-label-popup']}`} role="alert" aria-live="assertive">
            <span className={`${ImModuleStyle['DE-popup']}`}>{isShowD ? `Decision: You placed a ${dpObject.shippingtype.toLowerCase().replace("_", " ")} order of ${dpObject.quantityordered} units on ${dpObject.date.split(",")[0]}.` : `Event: ${dpObject.event}`}</span>
            <div className={`floating ui label  ${ImModuleStyle.ui} ${ImModuleStyle.label}`}>
              <img src={close_button} onClick={() => hideDecisionPopupHandler()} onKeyDown={() => hideDecisionPopupHandler()} />
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default RevenueGraph